<div>
    @if(pages.length === 1){
        <ng-container [ngTemplateOutlet]="guideContent" [ngTemplateOutletContext]="{ page: pages[0] }"></ng-container>
    }
    @if(pages.length > 1){
        <mat-horizontal-stepper #stepper [selectedIndex]="pageNumber" (selectionChange)="pageChange($event)">
            <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
            <ng-template matStepperIcon="done" let-index="index">{{ index + 1 }}</ng-template>
            <ng-template matStepperIcon="number" let-index="index">{{ index + 1 }}</ng-template>

            @for(page of pages; track page;){
            <mat-step>
                <ng-container [ngTemplateOutlet]="guideContent" [ngTemplateOutletContext]="{ page: page }"></ng-container>
            </mat-step>
            }
        </mat-horizontal-stepper>
    }
    <ng-template #guideContent let-page="page">
        <div class="sx-guide__content">
            @if(page?.image){
                <img class="sx-guide__image" src="{{ page.image }}">
            }
            <div class="sx-guide__text">
                @if(page?.heading){
                <h3 [innerHTML]="page.heading"></h3>
                }
                @if(page?.mainText){
                <div [innerHTML]="page.mainText | safeHtml" appRouterLink></div>
                }
            </div>
        </div>
    </ng-template>
    @if(pages && pages.length > 1){
        <div class="sxh-button-footer sxl-flex sxl-row sxl-justify-between">
            <div class="sxl-align-left sxl-horizontal-stack-small">
                <button mat-button class="sx-button" (click)="onPreviousPage()" id="guide_prev_btn" [disabled]="pageNumber === 0">
                {{ 'core.help.guides.previous' | translate }}
                </button>
                
                <button mat-button class="sx-button" (click)="onNextPage()" id="guide_next_btn" [disabled]="pageNumber === (pages.length - 1)">
                {{ 'core.help.guides.next' | translate }}
                </button>
            </div>
            <button mat-button class="sx-button sx-button--magenta sx-button--wide" (click)="onCancel()" id="guide_close_btn">
            {{ 'core.help.guides.close' | translate }}
            </button>
        </div>
    }
    @else {
        <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
            <button mat-button class="sx-button sx-button--magenta sx-button--wide" (click)="onCancel()" id="guide_close_btn">
            {{ 'core.help.guides.close' | translate }}
            </button>
        </div>
    }
</div>
  
